import React, { useEffect, useState } from "react";
import LeaveStyle from "../../Components/LeavesStyle";
import { Button, Image } from "antd";
import { Card, Typography as typography_antd } from "antd";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Logo from "../../assets/SpectusHRMS.png";
import "./newUser.css";
import AddIcon from "@mui/icons-material/Add";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import env from "../../config/env";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import CryptoJS from "crypto-js";
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY
const { Title } = typography_antd;

const initialUserDetails = {
  name: "",
  designation: "",
  company_email: "",
  personal_email: "",
  gender: "",
  phone_no: "",
  address: "",
  alternate_no: "",
  dob: null,
  profile_pic: "",
  identity_pic: "",
  aadhar_no: "",
  new_password: "",
  confirm_new_password: "",
  first_name: "",
  middle_name: "",
  last_name: "",
  bank_name: "",
  account_number: "",
  confirm_account_number: "",
  bank_ifsc: "",
  branch_name: ""
};

function NewUser() {
  const { userToken } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [errorText, setErrorText] = useState({
    gender: "",
    phone_no: "",
    address: "",
    personal_email: "",
    dob: "",
    alternate_no: "",
    aadhar_no: "",
    new_password: "",
    profile_pic: "",
    identity_pic: "",
    confirm_new_password: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    bank_name: "",
    account_number: "",
    confirm_account_number: "",
    bank_ifsc: "",
    branch_name: ""
  });
  const [userDefaultDetails, setUserDefaultDetails] = useState(initialUserDetails);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [profileImg, setProfileImg] = useState("");
  const [identityImg, setIdentityImg] = useState("");
  const [identityVal, setIdentityVal] = useState("");
  const [file, setFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [identityLoader, setIdentityLoader] = useState(false);
  const [profileLoader, setProfileLoader] = useState(false);
  const [salaryCheck, setSalaryCheck] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  useEffect(() => {
    if (identityImg) {
      setIdentityLoader(false);
    }
  }, [identityImg]);

  useEffect(() => {
    if (profileImg) {
      setProfileLoader(false);
    }
  }, [profileImg]);

  const validateFields = () => {
    let errorObj = {
      gender: "",
      phone_no: "",
      address: "",
      personal_email: "",
      dob: "",
      alternate_no: "",
      aadhar_no: "",
      new_password: "",
      profileImg: "",
      identity_pic: "",
      confirm_new_password: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      bank_name: "",
      account_number: "",
      confirm_account_number: "",
      bank_ifsc: "",
      branch_name: ""
    };

    if (!userDefaultDetails.gender) {
      errorObj.gender = "Gender is required!";
    }

    if (!userDefaultDetails.phone_no) {
      errorObj.phone_no = "Please enter your phone number!";
    }
    else if (!/^[0-9]{10}$/.test(userDefaultDetails.phone_no)) {
      errorObj.phone_no = "Please enter a 10-digit mobile number!";
    }

    if (!userDefaultDetails.address) {
      errorObj.address = "Please enter your Address!";
    }

    if (!userDefaultDetails.dob || userDefaultDetails.dob == "Invalid Date") {
      errorObj.dob = "Please enter your Date of Birth!";
    }

    if (
      userDefaultDetails.personal_email &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        userDefaultDetails.personal_email
      )
    ) {
      errorObj.personal_email = "Please enter a valid email address!";
    }

    if (
      userDefaultDetails.alternate_no &&
      !/^[0-9]{10}$/.test(userDefaultDetails.alternate_no)
    ) {
      errorObj.alternate_no = "Please enter a 10-digit mobile number!";
    }

    if (!userDefaultDetails.aadhar_no) {
      errorObj.aadhar_no = "Please enter your Adhar Card Number!";
    }

    if (
      userDefaultDetails?.aadhar_no &&
      !/^\d{12}$/.test(userDefaultDetails?.aadhar_no)
    ) {
      errorObj.aadhar_no = "Please input 12-digit Adhar Card Number";
    }

    if (profileFile == null) {
      errorObj.profile_pic = "Please enter your Profile Image!";
    }

    if (file == null) {
      errorObj.identity_pic = "Please enter your Identity Image!";
    }

    if (!userDefaultDetails.new_password) {
      errorObj.new_password = "Please enter your password!";
    }

    if (userDefaultDetails.new_password && !/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,18}$/.test(userDefaultDetails.new_password)) {
      errorObj.new_password = "Must contain at least one capital letter and one number and a special character and it has 8 to 18 characters.";
    }

    if (!userDefaultDetails.confirm_new_password) {
      errorObj.confirm_new_password = "Please enter your confirm password!";
    }

    if (
      userDefaultDetails.confirm_new_password !==
      userDefaultDetails.new_password
    ) {
      errorObj.confirm_new_password = "Please enter same password!";
    }

    if (salaryCheck > 0) {
      if (userDefaultDetails.account_number && !/^[0-9]{9,18}$/.test(userDefaultDetails.account_number)) {
        errorObj.account_number = "Please enter a proper Account Nnumber!";
      }

      if (
        userDefaultDetails.bank_ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(userDefaultDetails.bank_ifsc)) {
        errorObj.bank_ifsc = "Please enter a proper Bank IFSC Code!";
      }

      if (!userDefaultDetails.first_name) {
        errorObj.first_name = "Please enter a First Name";
      }

      if (!userDefaultDetails.middle_name) {
        errorObj.middle_name = "Please enter a Middle Name";
      }

      if (!userDefaultDetails.last_name) {
        errorObj.last_name = "Please enter a Last Name";
      }

      if (!userDefaultDetails.bank_name) {
        errorObj.bank_name = "Please enter a Bank Name";
      }

      if (!userDefaultDetails.account_number) {
        errorObj.account_number = "Please enter a Account Nnumber";
      }

      if (!userDefaultDetails.confirm_account_number) {
        errorObj.confirm_account_number = "Please enter a confirm account  Nnumber";
      }

      if (
        userDefaultDetails.confirm_account_number !==
        userDefaultDetails.account_number
      ) {
        errorObj.confirm_account_number = "Please enter same account number!";
      }

      if (!userDefaultDetails.bank_ifsc) {
        errorObj.bank_ifsc = "Please enter a Bank IFSC Code!";
      }

      if (!userDefaultDetails.branch_name) {
        errorObj.branch_name = "Please enter a Branch Nmae!";
      }
    }

    setErrorText({ ...errorObj });
    return !Object.values(errorObj).some((error) => error);
  };

  const checkSalary = async () => {
    try {

      const checkSalary = CryptoJS.SHA256("/checkSalary" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const encodedToken = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(userToken), SECRET_KEY).toString());

      const res = await fetch(
        `${env.backend_api_endpoint}/${checkSalary}/?token=${encodedToken}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

      const response = await res.json();
      setSalaryCheck(response.success);
      console.log(res.data); // { success: true/false }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    checkSalary();
  }, [])

  const onFinish = async () => {

    // if (preventDoubleClick) return;
    // setpreventDoubleClick(true);

    let profileImgUrl = '';
    let identityFileurl = '';
    if (validateFields()) {

      console.log(validateFields());

      try {
        if (profileFile !== null) {
          profileImgUrl = await handleFileUpload(profileFile)
        }
        if (file !== null) {
          identityFileurl = await handleFileUpload(file);
        }
        setpreventDoubleClick(true);
        try {

          const data = {
            personalEmail: userDefaultDetails?.personal_email ? userDefaultDetails?.personal_email : null,
            phoneNo: userDefaultDetails?.phone_no,
            alternateNo: userDefaultDetails?.alternate_no,
            dob: userDefaultDetails?.dob,
            address: userDefaultDetails?.address,
            gender: userDefaultDetails?.gender,
            aadharNo: userDefaultDetails?.aadhar_no,
            password: userDefaultDetails?.confirm_new_password,
            profilePic: profileImgUrl,
            identityPic: identityFileurl,
            firstName: userDefaultDetails?.first_name,
            middleName: userDefaultDetails?.middle_name,
            lastName: userDefaultDetails?.last_name,
            bankName: userDefaultDetails?.bank_name,
            accountNumber: userDefaultDetails?.account_number,
            bankIFSC: userDefaultDetails?.bank_ifsc,
            branchName: userDefaultDetails?.branch_name

          }

          const newUser = CryptoJS.SHA256("/newUser" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

          const encryptedResponse = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
          const encodedToken = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(userToken), SECRET_KEY).toString());

          const response = await fetch(
            `${env.backend_api_endpoint}/${newUser}/?token=${encodedToken}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ encryptedData: encryptedResponse }),
            }
          );
          if (response.ok) {
            const successData = await response.json();
            if (successData.status === 200) {
              setUserDefaultDetails({
                gender: "",
                phone_no: "",
                address: "",
                personal_email: "",
                dob: "",
                alternate_no: "",
                aadhar_no: "",
                new_password: "",
                profile_pic: "",
                identity_pic: "",
                confirm_new_password: "",
                first_name: "",
                middle_name: "",
                last_name: "",
                bank_name: "",
                account_number: "",
                confirm_account_number: "",
                bank_ifsc: "",
                branch_name: ""
              });
              toast.success("Profile Updated successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                toastId: "1",
              });
              navigate("/login");
            }
          }
        } catch (error) {
          console.error("Error New User in:", error.message);
        }
      }
      catch (err) {
        console.error("error Upload API", err)
      }

      finally {
        setpreventDoubleClick(false);
      }
    }
  };

  // useEffect(() => {
  //   if (identityVal) {
  //     handleFileUpload();
  //   }
  // }, [identityVal]);

  const handleProfilePic = (event) => {
    const selectedFile = event.target.files[0];
    setProfileFile(selectedFile);
    setIdentityVal("Profile");
  };

  const handleIdentityPic = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setIdentityVal("Identity");
  };

  let tempData = "";
  // const handleFileUpload = async (fileData) => {
  //   const formData = new FormData();
  //   formData.append("file", fileData);

  //   // if (identityVal === "Identity") {
  //   //   setIdentityLoader(true);
  //   // }
  //   // if (identityVal === "Profile") {
  //   //   setProfileLoader(true);
  //   // }
  //   await axios
  //     .post(`${env.backend_api_endpoint}/upload`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then((response) => {
  //       tempData = response.data.filename;
  //       // if (identityVal === "Profile") {
  //       // setProfileImg(response.data.filename);
  //       // setUserDefaultDetails({
  //       //   ...userDefaultDetails,
  //       //   profile_pic: response?.data?.fileName,
  //       // });
  //       // }
  //       // if (identityVal === "Identity") {
  //       // setIdentityImg(response.data.filename);
  //       // setUserDefaultDetails({
  //       //   ...userDefaultDetails,
  //       //   identity_pic: response?.data?.fileName,
  //       // });
  //       // }
  //       // toast.success("Uploaded successfully!", {
  //       //   position: toast.POSITION.TOP_RIGHT,
  //       //   toastId: "1",
  //       // });
  //     })
  //     .catch((error) => {
  //       console.log(error.response.data.error);
  //     });
  //   return tempData
  // };

  const handleFileUpload = async (fileData) => {
    const formData = new FormData();
    formData.append("file", fileData);

    const response = await axios.post(
      `${env.backend_api_endpoint}/upload`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data.filename;
  };
  return (
    <LeaveStyle>
      <div
        style={{
          padding: "40px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card
          bodyStyle={{ height: "85vh", width: "80vw" }}
          bordered={false}
          style={{
            margin: 15,
          }}
        >
          <div
            className="new_user_img_div"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image src={Logo} preview={false}></Image>
          </div>
          <div className="form_data_div">
            <div
              style={{
                display: "flex",
                marginTop: "3px",
                fontFamily: "ImportedMilliardBold",
              }}
            >
              <Title
                level={2}
                style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
              >
                Profile
              </Title>
            </div>

            {!loading ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <div>
                    <Typography className="label_text_profile">
                      Upload Profile Picture{" "}
                      <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <label
                      htmlFor="upload-photo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        width: "155px",
                      }}
                    >
                      <input
                        style={{ display: "none" }}
                        id="upload-photo"
                        name="upload-photo"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          handleProfilePic(e);
                        }}
                      />

                      <div
                        style={{
                          height: "70px",
                          width: "70px",
                          backgroundColor: "#8080805e",
                          borderRadius: "50%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {!profileLoader ? (
                          <>
                            {" "}
                            {
                              profileFile !== null
                                ?
                                <>
                                  <img
                                    style={{
                                      height: "80px",
                                      width: "80px",
                                      borderRadius: "50%",
                                      objectFit: "fill",
                                    }}
                                    src={URL.createObjectURL(profileFile)}
                                    alt={profileFile}
                                  />
                                </>
                                :
                                <AddIcon style={{ fontSize: "40px" }} />
                            }
                            {/* {userDefaultDetails?.profile_pic || profileImg ? (
                                <>
                                  <img
                                    style={{
                                      height: "80px",
                                      width: "80px",
                                      borderRadius: "50%",
                                      objectFit: "fill",
                                    }}
                                    src={`${env.backend_api_endpoint}/files/${
                                      profileImg
                                        ? profileImg
                                        : userDefaultDetails?.profile_pic
                                    }`}
                                    alt={`${userDefaultDetails?.profile_pic}`}
                                  />
                                </>
                              ) 
                              : (
                                <AddIcon style={{ fontSize: "40px" }} />
                              )} */}
                          </>
                        ) : (
                          <div>
                            <CircularProgress />
                          </div>
                        )}
                      </div>
                    </label>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errorText?.profile_pic && errorText?.profileImg}
                    </FormHelperText>
                  </div>
                </div>

                <div className="profileItem">
                  <div>
                    <Typography className="label_text_profile">
                      Personal Email{" "}
                    </Typography>

                    <TextField
                      placeholder="Enter Personal Email"
                      value={userDefaultDetails?.personal_email}
                      autoComplete="off"
                      onChange={(e) => {
                        setErrorText({ personal_email: "" });
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          personal_email: e.target.value,
                        });
                      }}
                      error={errorText.personal_email}
                      helperText={errorText.personal_email}
                      fullWidth
                    />
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      Gender <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="radio-buttons-group"
                      defaultValue={userDefaultDetails?.gender}
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          gender: e.target.value,
                        });
                        setErrorText({
                          ...errorText,
                          gender: "",
                        });
                      }}
                      error={errorText.gender}
                      helperText={errorText.gender}
                    >
                      <FormControlLabel
                        key="Male"
                        value="Male"
                        control={<Radio />}
                        label="Male"
                      />
                      <FormControlLabel
                        key="Female"
                        value="Female"
                        control={<Radio />}
                        label="Female"
                      />
                    </RadioGroup>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errorText.gender}
                    </FormHelperText>
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      Date Of Birth <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className={`Dob ${errorText.dob ? "error" : ""}`}
                        fullWidth
                        format="DD-MM-YYYY"
                        value={
                          userDefaultDetails?.dob
                            ? dayjs(userDefaultDetails?.dob)
                            : null
                        }
                        onChange={(e) => {
                          setErrorText({
                            ...errorText,
                            dob: "",
                          });
                          setUserDefaultDetails({
                            ...userDefaultDetails,
                            dob: e.format("YYYY-MM-DD"),
                          });
                        }}
                        error={errorText.dob}
                      />
                    </LocalizationProvider>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errorText.dob}
                    </FormHelperText>
                  </div>

                  <div>
                    <Typography className="label_text_profile">
                      Phone Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      placeholder="Enter Phone Number"
                      fullWidth
                      value={userDefaultDetails?.phone_no}
                      type="number"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">+91</InputAdornment>
                        ),
                      }}
                      inputProps={{
                        inputMode: "numeric", // Ensures mobile keyboards show numbers
                        pattern: "[0-9]*", // Allows only digits
                        min: 0, // Ensures the value can't be negative
                      }}
                      onKeyDown={(e) => {
                        if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          phone_no: e.target.value,
                        });
                        if (e.target.value !== "") {
                          setErrorText({
                            ...errorText,
                            phone_no: "",
                          });
                        } else {
                          setErrorText({
                            ...errorText,
                            phone_no: "Please input your phone number!",
                          });
                        }
                      }}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                      error={errorText.phone_no}
                      helperText={errorText.phone_no}
                    />
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      Alternate Number
                    </Typography>
                    <TextField
                      placeholder="Enter Alternate Phone Number"
                      fullWidth
                      value={userDefaultDetails?.alternate_no}
                      type="number"
                      autoComplete="off"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">+91</InputAdornment>
                        ),
                      }}

                      onKeyDown={(e) => {
                        if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      onChange={(e) => {
                        setErrorText({ alternate_no: "" });
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          alternate_no: e.target.value,
                        });
                      }}

                      inputProps={{
                        inputMode: "numeric", // Ensures mobile keyboards show numbers
                        pattern: "[0-9]*", // Allows only digits
                        min: 0, // Ensures the value can't be negative
                      }}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                      error={errorText.alternate_no}
                      helperText={errorText.alternate_no}
                    />
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      Adhar Card Number
                      <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <TextField
                      placeholder="Adhar Card Number"
                      value={userDefaultDetails?.aadhar_no}
                      type="number"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 12))
                      }
                      inputProps={{
                        inputMode: "numeric", // Ensures mobile keyboards show numbers
                        pattern: "[0-9]*", // Allows only digits
                        min: 0, // Ensures the value can't be negative
                      }}
                      onKeyDown={(e) => {
                        if (["-", "+", "e", ".", "E", "ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          aadhar_no: e.target.value,
                        });
                        if (e.target.value !== "") {
                          setErrorText({
                            ...errorText,
                            aadhar_no: "",
                          });
                        } else {
                          setErrorText({
                            ...errorText,
                            aadhar_no: "Please input your adhar card number!",
                          });
                        }
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          aadhar_no: e.target.value,
                        });
                      }}
                      error={errorText.aadhar_no}
                      helperText={errorText.aadhar_no}
                      fullWidth
                    />
                  </div>
                  <div>
                    <div style={{ display: "flex" }}>
                      <div>
                        <Typography className="label_text_profile">
                          Upload Identity Proof
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>
                        <label
                          htmlFor="upload-identity-photo"
                          style={{ display: "flex", width: "155px" }}
                        >
                          <input
                            style={{ display: "none" }}
                            id="upload-identity-photo"
                            name="upload-identity-photo"
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              handleIdentityPic(e);
                            }}
                          />

                          <div
                            style={{
                              backgroundColor: "rgb(36,77,160)",
                              padding: "8px 15px",
                              color: "white",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <FileUploadIcon /> Upload File
                          </div>
                        </label>
                      </div>
                      {!identityLoader ? (
                        file !== null && (
                          <img
                            style={{
                              height: "70px",
                              width: "100px",
                              marginTop: "10px",
                              marginLeft: "10px",
                              objectFit: "fill",
                            }}
                            src={URL.createObjectURL(file)}
                            alt={file}
                          />
                        )
                      ) : (
                        <div
                          style={{
                            height: "70px",
                            width: "100px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "10px",
                            marginLeft: "10px",
                            objectFit: "fill",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      )}
                    </div>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errorText.identity_pic}
                    </FormHelperText>
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      Address <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      placeholder="Enter Address"
                      fullWidth
                      value={userDefaultDetails?.address}
                      multiline
                      rows={3}
                      autoComplete="off"
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          address: e.target.value,
                        });
                        if (e.target.value !== "") {
                          setErrorText({
                            ...errorText,
                            address: "",
                          });
                        } else {
                          setErrorText({
                            ...errorText,
                            address: "Please input your Address!",
                          });
                        }
                      }}
                      error={errorText.address}
                      helperText={errorText.address}
                    />
                  </div>
                  <div>
                    <Typography className="label_text_profile">
                      New Password <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <OutlinedInput
                      placeholder="New Password"
                      fullWidth
                      value={userDefaultDetails.new_password}
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          new_password: e.target.value,
                        });
                        if (e.target.value !== "") {
                          setErrorText({
                            ...errorText,
                            new_password: "",
                          });
                        } else {
                          setErrorText({
                            ...errorText,
                            new_password: "Please input your Password!",
                          });
                        }
                      }}
                      size="medium"
                      autoComplete="off"
                    />
                    <FormHelperText id="helper_text">
                      {errorText?.new_password ? errorText?.new_password : ""}
                    </FormHelperText>
                  </div>
                  <div>
                    <Typography
                      className="label_text_profile"
                      style={{ marginTop: "10px" }}
                    >
                      Confirm New Password
                      <span style={{ color: "red" }}>*</span>{" "}
                    </Typography>
                    <OutlinedInput
                      placeholder="Confirm New Password"
                      value={userDefaultDetails.confirm_new_password}
                      type={showConfirmPassword ? "text" : "password"}
                      fullWidth
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickConfirmShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      onChange={(e) => {
                        setUserDefaultDetails({
                          ...userDefaultDetails,
                          confirm_new_password: e.target.value,
                        });
                        if (e.target.value !== "") {
                          setErrorText({
                            ...errorText,
                            confirm_new_password: "",
                          });
                        } else {
                          if (
                            e.target.value !== userDefaultDetails?.new_password
                          ) {
                            setErrorText({
                              ...errorText,
                              confirm_new_password:
                                "Please input same Password!",
                            });
                          }
                          if (e.target.value === "") {
                            setErrorText({
                              ...errorText,
                              confirm_new_password:
                                "Please input your Confirm Password!",
                            });
                          }
                        }
                      }}
                      size="medium"
                      autoComplete="off"
                    />
                    <FormHelperText id="helper_text">
                      {errorText?.confirm_new_password
                        ? errorText?.confirm_new_password
                        : ""}
                    </FormHelperText>
                  </div>
                  <div></div>

                </div>

                {salaryCheck == true &&
                  <>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "15px",
                        fontFamily: "ImportedMilliardBold",
                      }}
                    >
                      <Title
                        level={3}
                        style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
                      >
                        Bank Details
                      </Title>
                    </div>

                    <div className="profileItem">
                      <div>
                        <Typography className="label_text_profile">
                          First Name(As per the bank document)
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter First Name"
                          value={userDefaultDetails?.first_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ first_name: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              first_name: e.target.value,
                            });
                          }}
                          error={errorText.first_name}
                          helperText={errorText.first_name}
                          fullWidth
                        />
                      </div>

                      <div>
                        <Typography className="label_text_profile">
                          Middle Name (As per the bank document)
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Middle Name"
                          value={userDefaultDetails?.middle_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ middle_name: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              middle_name: e.target.value,
                            });
                          }}
                          error={errorText.middle_name}
                          helperText={errorText.middle_name}
                          fullWidth
                        />
                      </div>

                      <div>
                        <Typography className="label_text_profile">
                          Last Name (As per the bank document)
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Last Name"
                          value={userDefaultDetails?.last_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ last_name: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              last_name: e.target.value,
                            });
                          }}
                          error={errorText.last_name}
                          helperText={errorText.last_name}
                          fullWidth
                        />
                      </div>

                      <div>
                        <Typography className="label_text_profile">
                          Bank Name
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Bank Name"
                          value={userDefaultDetails?.bank_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ bank_name: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              bank_name: e.target.value,
                            });
                          }}
                          error={errorText.bank_name}
                          helperText={errorText.bank_name}
                          fullWidth
                        />
                      </div>

                      <div>
                        <Typography className="label_text_profile">
                          Account Number
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Account Number"
                          value={userDefaultDetails?.account_number}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ account_number: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              account_number: e.target.value,
                            });
                          }}
                          error={errorText.account_number}
                          helperText={errorText.account_number}
                          fullWidth
                        />
                      </div>
                      <div>
                        <Typography className="label_text_profile">
                          Confirm Account Number
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Confirm Account Number"
                          value={userDefaultDetails?.confirm_account_number}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ confirm_account_number: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              confirm_account_number: e.target.value,
                            });
                          }}
                          error={errorText.confirm_account_number}
                          helperText={errorText.confirm_account_number}
                          fullWidth
                        />
                      </div>
                      <div>
                        <Typography className="label_text_profile">
                          Bank IFSC Code
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Bank IFSC Code"
                          value={userDefaultDetails?.bank_ifsc}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ bank_ifsc: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              bank_ifsc: e.target.value,
                            });
                          }}
                          error={errorText.bank_ifsc}
                          helperText={errorText.bank_ifsc}
                          fullWidth
                        />
                      </div>
                      <div>
                        <Typography className="label_text_profile">
                          Branch Name
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Typography>

                        <TextField
                          placeholder="Enter Branch Name"
                          value={userDefaultDetails?.branch_name}
                          autoComplete="off"
                          onChange={(e) => {
                            setErrorText({ branch_name: "" });
                            setUserDefaultDetails({
                              ...userDefaultDetails,
                              branch_name: e.target.value,
                            });
                          }}
                          error={errorText.branch_name}
                          helperText={errorText.branch_name}
                          fullWidth
                        />
                      </div>
                    </div>
                  </>
                }
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <LoadingButton
                    className="profile_btn"
                    size="large"
                    variant="contained"
                    id="submit_btn"
                    onClick={onFinish}
                    loading={preventDoubleClick}
                    block
                    style={{
                      backgroundColor: "rgb(36,77,160)",
                      marginTop: "25px",
                      height: "44px",
                      width: "130px",
                    }}
                  >
                    <span>{preventDoubleClick ? "" : "Submit"}</span>
                  </LoadingButton>
                </div>
              </>
            ) : (
              <span
                class="loader"
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></span>
            )}
          </div>
        </Card>
      </div>
    </LeaveStyle>
  );
}

export default NewUser;
